import {
   GET_CATEGORIES_DOCUMENTS_HAS_TYPE,
   GET_CATEGORIES_DOCUMENTS,
   CHANGE_INPUT_VALUE_CATEGORY_DOCUMENT,
   SAVE_CATEGORY_DOCUMENT,
   GET_INFO_CATEGORY_DOCUMENT,
   DELETE_CATEGORY_DOCUMENT,
   CATEGORY_DOCUMENT_DEFAULT_DATA
} from '../constants/categories_documents';

export const categories_documents = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_CATEGORIES_DOCUMENTS_HAS_TYPE : {
         return action.payload;
      }

      case GET_CATEGORIES_DOCUMENTS : {
         return action.payload;
      }

      case CHANGE_INPUT_VALUE_CATEGORY_DOCUMENT : {
         return action.payload;
      }

      case SAVE_CATEGORY_DOCUMENT : {
         return action.payload;
      }

      case GET_INFO_CATEGORY_DOCUMENT : {
         return action.payload;
      }

      case DELETE_CATEGORY_DOCUMENT : {
         return action.payload;
      }

      case CATEGORY_DOCUMENT_DEFAULT_DATA : {
         return action.payload;
      }
 
     default :
     return state;
   }
}